import { UAParser } from "ua-parser-js";

import { LINKS } from "./constants";

export interface ReportIssueDetails {
  gameName?: string;
  userId?: string;
  username?: string;
}

function getDeviceReportDetails() {
  const parser = new UAParser();
  const { device, os } = parser.getResult();

  return {
    model: device.model || device.vendor || "",
    phoneType: os.name || "",
    osVersion: os.version || "",
    appVersionNumber: process.env.REACT_APP_X_APP_BUILD || "",
  };
}

export function fillReportIssueUrl({
  gameName,
  userId,
  username,
}: ReportIssueDetails): string {
  const parsed = new URL(LINKS.WEBPAGE.REPORT_ISSUE);
  const device = getDeviceReportDetails();

  parsed.searchParams.set("game_name", gameName ?? "");
  parsed.searchParams.set("model", device.model);
  parsed.searchParams.set("phone_type", device.phoneType);
  parsed.searchParams.set("os_version", device.osVersion);
  parsed.searchParams.set("user_id", userId ?? "");
  parsed.searchParams.set("username", username ?? "");
  parsed.searchParams.set("app_version_number", device.appVersionNumber);

  return parsed.toString();
}

export function openReportIssue(details: ReportIssueDetails) {
  window.open(fillReportIssueUrl(details), "_blank", "noopener,noreferrer");
}
